<template>
  <div class="goonamcontainer">
    <md-field>
      <md-input-item
        ref="input"
        maxlength="10"
        placeholder="請輸入物品名稱"
        v-model="name"
      >
        <md-button type="primary" size="small" slot="right" @click="getname"
          >確定</md-button
        >
      </md-input-item>
      <p
        style="
          color: rgba(246, 57, 13, 1);
          font-size: 0.22rem;
          text-align: left;
          padding: 0.3rem 0;
        "
      >
        請簡短描述品名，如“衣服”、“鞋子”、“玩具”，限10 個中文字元
      </p>
      <md-cell-item title="歷史品名" no-border v-if="goodlist.length > 0">
        <md-icon
          name="delete"
          size="lg"
          slot="right"
          @click="deletall"
        ></md-icon>
      </md-cell-item>
      <div style="display: flex; flex-wrap: wrap; padding-bottom: 0.2rem">
        <div
          v-for="(item, index) in goodlist"
          :key="index"
          class="gooname"
          @click="back(item)"
        >
          <span>{{ item }}</span>
        </div>
      </div>
    </md-field>
  </div>
</template>

<script>
import eventBus from "../../until/eventBus";
import { InputItem, Field, Icon, Button, CellItem,Toast} from "mand-mobile";
export default {
  name: "goodname",
  components: {
    [CellItem.name]: CellItem,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Button.name]: Button,
  },
  data() {
    return {
      goodlist: [],
      name: "",
    };
  },
  activated() {
    this.name = "";
    if (localStorage.getItem("goodName")) {
      this.goodlist = JSON.parse(localStorage.getItem("goodName"));
    } else {
      this.goodlist = [];
    }
    this.$refs.input.focus();
  },
  methods: {
    getname() {
      if (this.name) {
        var myregs = /^(?![a-zA-Z]+$)([a-zA-Z\u4e00-\u9fa5])+$/g;
        if (myregs.test(this.name)) {
          this.strogname();
        } else {
          Toast.failed("物品名称只能为中文或中英文组合");
        }
      } else {
        this.$router.go(-1);
      }
    },
    deletall() {
      localStorage.removeItem("goodName");
      this.goodlist = [];
    },
    back(info) {
       var myregs = /^(?![a-zA-Z]+$)([a-zA-Z\u4e00-\u9fa5])+$/g;
        if (myregs.test(info)) {
           eventBus.$emit("goodeNameinfo", info, this.$route.query.index);
      this.$router.go(-1);
        } else {
          Toast.failed("物品名称只能为中文或中英文组合");
        }
   
    },
    strogname() {
      if (localStorage.getItem("goodName")) {
        var list = JSON.parse(localStorage.getItem("goodName"));
        list.push(this.name);
        localStorage.setItem("goodName", JSON.stringify(list));
        this.back(this.name);
      } else {
        var list = [];
        list.push(this.name);
        localStorage.setItem("goodName", JSON.stringify(list));
        this.back(this.name);
      }
    },
  },
};
</script>

<style lang="less">
.goonamcontainer {
  .md-field {
    padding: 0 0.4rem;
  }
  .md-cell-item-title {
    text-align: left;
  }
  .md-cell-item-body {
    padding-top: 0;
  }
  .gooname {
    display: inline-block;
    margin-right: 0.15rem;
    padding: 0.05rem 0.24rem;
    background-color: #f0f0f2;
    border-radius: 0.1rem;
    margin-bottom: 0.2rem;
    color: #333333;
    font-size: 0.28rem;
  }
}
</style>
